<template>
  <meetings />
</template>

<script>
import Meetings from "@/components/3pl/CRM/Meetings/Home";
export default {
  components: {
    Meetings,
  },
};
</script>

<style></style>
